import { createSlice } from "@reduxjs/toolkit";

export const userSlice = createSlice({
  name: "user",
  initialState: {
    isLoggedIn: false,
  },
  reducers: {
    setLoginData: (state, action) => {
      state.isLoggedIn = action.payload || null;
    },
  },
});

export const { setLoginData, setUserName } = userSlice.actions;

export const selectIsLoggedIn = (state) => state.userData.isLoggedIn;

export default userSlice.reducer;
